import {PlayerReduxState} from "../types";
import getCurrentAction from "./getCurrentAction";
import {PhraseVariant} from "../../../components/Phrase";
import {isAnyUserInputAction} from "../utils";
import {ChallengeMode} from "../../../schema";

export default function getCurrentActionPhraseMode(state: PlayerReduxState) {
  const action = getCurrentAction(state);

  if (!action || !isAnyUserInputAction(action)) {
    return undefined;
  }

  switch (state.challenge.mode) {
    case ChallengeMode.CHOICES_WITH_CUSTOM_SCORES:
    case ChallengeMode.CHOICE_BASED_STUDY:
    case ChallengeMode.COMPETENCE_TEST:
    case ChallengeMode.CUSTOM_PARAMETERS_TEST:
      return PhraseVariant.DEFAULT;

    case ChallengeMode.RPG_MODE:
      return PhraseVariant.HIDDEN;

    default:
      console.warn("getCurrentActionPhraseMode: unsupported lesson mode");
      return PhraseVariant.DEFAULT;
  }
}
